import { DrilldownKeys } from "../../../helpers/reports.helper.types";

export const widgetTitles: Record<
  DrilldownKeys,
  { short: string; long: string }
> = {
  [DrilldownKeys.Webfilter]: {
    short: "web_filters",
    long: "web_filter",
  },
  [DrilldownKeys.Malware]: {
    short: "malware_and_phishing",
    long: "malware_and_phishing_title",
  },
  [DrilldownKeys.Botnet]: {
    short: "botnet",
    long: "botnet",
  },
};
